<template>
  <nav class="bg-white shadow-lg">
    <div class="max-w mx-auto flex justify-between items-center px-6">
      <!-- Logo -->
      <div class="flex items-center">
        <router-link to="/home">
          <img src="../assets/logo.png" alt="Kwisoko logo" class="h-16 sm:h-30">
        </router-link>
      </div>

      <!-- Hamburger Icon for Mobile -->
      <div class="sm:hidden p-4">
        <button @click="toggleMobileMenu" class="text-gray-700 focus:outline-none">
          <i class="fas" :class="mobileMenuOpen ? 'fa-times' : 'fa-bars'"></i>
        </button>
      </div>

      <!-- Navigation Links (Desktop) -->
      <ul class="hidden sm:flex space-x-4 items-center">
        
        <li v-if="!isLoggedIn">
          <router-link to="/login" class="text-gray-700 hover:text-green">SignIn</router-link>
        </li>

        <li v-if="isLoggedIn" class="relative">
          <div @click="toggleModal" class="cursor-pointer bg-green text-white rounded-full h-10 w-10 flex items-center justify-center font-bold">
            {{ initials }}
          </div>
          <div v-if="showModal" class="absolute right-0 mt-6 w-48 bg-white rounded-lg shadow-lg z-50">
            <ul class="py-2">
              <li>
                <router-link to="/profile" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Profile</router-link>
              </li>
              <li>
                <button @click="logoutUser" class="w-full text-center block px-4 py-2 text-gray-700 hover:bg-gray-100">
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>

    <!-- Mobile Menu -->
    <div v-if="mobileMenuOpen" class="sm:hidden">
      <ul class="flex flex-col space-y-2 mt-4">
        <li>
          <router-link @click="closeMobileMenu" to="/home" class="text-gray-700 hover:text-green">View Available Items</router-link>
        </li>
        <li v-if="user">
          <router-link @click="closeMobileMenu" to="/myorders" class="text-gray-700 hover:text-green">View My Orders</router-link>
        </li>
        <li v-if="!isLoggedIn">
          <router-link @click="closeMobileMenu" to="/login" class="text-gray-700 hover:text-green">SignIn</router-link>
        </li>
        <li v-if="!isLoggedIn">
          <router-link @click="closeMobileMenu" to="/register" class="text-gray-700 hover:text-green">SignUp</router-link>
        </li>

        <!-- Cart Icon in Mobile Menu -->
        <li>
          <router-link @click="closeMobileMenu" to="/orderdetails" class="relative text-gray-700 hover:text-green">
            <i class="fas fa-shopping-cart"></i>
            <span v-if="cartItemCount > 0" class="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center">
              {{ cartItemCount }}
            </span>
          </router-link>
        </li>

        <li v-if="isLoggedIn" class="relative">
          <div @click="toggleModal" class="cursor-pointer bg-green text-white rounded-full h-10 w-10 flex items-center justify-center font-bold">
            {{ initials }}
          </div>
          <div v-if="showModal" class="absolute right-0 mt-4 w-48 bg-white rounded-lg shadow-lg z-50">
            <ul class="py-2">
              <li>
                <router-link @click="closeMobileMenu" to="/profile" class="block px-4 py-2 text-gray-700 hover:bg-gray-100">Profile</router-link>
              </li>
              <li>
                <button @click="logoutUser" class="w-full text-center block px-4 py-2 text-gray-700 hover:bg-gray-100">
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueJwtDecode from 'vue-jwt-decode';

export default {
  data() {
    return {
      showModal: false,
      mobileMenuOpen: false, // State for mobile menu
    };
  },
  computed: {
    ...mapState('auth', {
      user: state => state.user,
      initials: state => state.initials,
      isLoggedIn: state => state.isLoggedIn
    }),
    ...mapState('orders',{
      orders : state => state.orders,
    }),
    cartItemCount() {
      return this.orders.items.length; // Assuming cart is stored in Vuex store
    }
  },
  methods: {
    ...mapActions('auth', ['setUser', 'logout']),
    
    toggleModal() {
      this.showModal = !this.showModal;
    },
    
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen; // Toggle the mobile menu
    },
    
    closeMobileMenu() {
      this.mobileMenuOpen = false; // Close the mobile menu when a link is clicked
    },

    async checkLoginStatus() {
      const token = localStorage.getItem('token');
      if (token) {
        const decodedToken = VueJwtDecode.decode(token);
        this.setUser(decodedToken.user);
      }
    },

    logoutUser() {
      this.logout();
      this.showModal = false;
      this.mobileMenuOpen = false;
    }
  },
  mounted() {
    this.checkLoginStatus();
  }
};
</script>
